var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificateExpired = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.847 7.844h-.1c-.673 0-1.208.576-1.208 1.296v8.492c0 .63.302 1.223.821 1.547l6.958 4.48a1.15 1.15 0 0 0 1.643-.431c.352-.612.167-1.421-.42-1.782l-6.488-4.139V9.141c0-.72-.536-1.297-1.206-1.297Z"
})));
export default SvgCertificateExpired;